import { api } from './api';

const userTypesgetList = async () => {
    const response = await api({
        url: `UserTypes/getList`,
        method: 'GET',
    });
    return response.data;
};

const userTypesServices = {
  userTypesgetList,
};

export default userTypesServices;
